import React, { PropTypes } from 'react';

const BackButton = (props) => {
    const { activeId, pagesList, actions } = props;

    const goToPrevPage = () => {
        const redirectToPage = pagesList[pagesList.indexOf(activeId) - 1];
        actions.setActivePage(redirectToPage);
    };

    return (
        <span className="nav-btns__back" onClick={goToPrevPage} title="Go back">back &#47;</span>
    );
};

BackButton.propTypes = {
    activeId: PropTypes.number.isRequired,
    pagesList: PropTypes.array.isRequired,
    actions: PropTypes.object.isRequired,
};

export default BackButton;



// WEBPACK FOOTER //
// ./src/_app/quick_response/components/Content/UI/NavButtons/Back.jsx